import { ComponentHelper } from "../core/util/componentHelper";
import { IsNumericTextBox } from "../core/components/isNumericTextBox";
import { TextBox } from "../core/components/textBox";
import { FieldInstance } from "../core/components/field";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { Helper } from "../core/util/helper";
import { FAIcon } from "../core/components/faIcon";
import React from "react";

interface StupidSQLProps {
    field: any;
    value: string;
    onChange: (field, value, dataItem) => void;
}

interface StupidSQLState {
    gruppe: number;
    zaehler: number;
    query: string;
    loadingState: "loaded" | "loading" | "none";
}

export default class StupidSQL extends React.Component<StupidSQLProps, StupidSQLState>{
    private factory = ComponentHelper.createFactory();
    constructor(props: StupidSQLProps) {
        super(props)
        const value = props.value ?? "";
        const arr = value.split(";");
        if (arr.length == 2) {
            const [gruppe, zaehler] = arr;

            this.state = {
                gruppe: parseInt(gruppe),
                query: null,
                zaehler: parseInt(zaehler),
                loadingState: "none"
            }
        } else {
            this.state = {
                gruppe: null,
                query: null,
                zaehler: null,
                loadingState: "none"
            }
        }
    }

    private onValueChange = async () => {        
        this.props.onChange(this.props.field, `${this.state.gruppe};${this.state.zaehler}`, { columns: [] });
        this.loadSQL();
    }

    private loadSQL = () => {
        if (!Helper.hasValue(this.state.gruppe) || !Helper.hasValue(this.state.zaehler))
            return;

        this.setState({ loadingState: "loading" }, async () => {
            const { Code, Data, Message } = await HTTPService.noBusyIndicator().get<JsonResultClass<string>>(`EditIndividualFields/ReadFromFeldinhaltM?gruppe=${this.state.gruppe}&zaehler=${this.state.zaehler}`);
            this.setState({ query: Data, loadingState: "loaded" });
            this.props.onChange(this.props.field, `${this.state.gruppe};${this.state.zaehler}`, { columns: [], query: Data });
        });
    }

    private renderGruppeTextBox = () => {
        const props = this.factory.getDefaultNumericTextBoxProps();
        //props.required = true;
        props.value = this.state.gruppe;
        props.field.name = "Gruppe";
        props.onChange = (_, value: number) => {
            this.setState({ gruppe: value }, this.onValueChange);
        }


        return (
            <FieldInstance label={"Gruppe*"} noHover={true}>
                <IsNumericTextBox {...props} />
            </FieldInstance>
        )
    }

    private renderZaehlerTextBox = () => {
        const props = this.factory.getDefaultNumericTextBoxProps();
        //props.required = true;
        props.value = this.state.zaehler;
        props.field.name = "Zaehler";
        props.onChange = (_, value: number) => {
            this.setState({ zaehler: value }, this.onValueChange);
        }


        return (
            <FieldInstance label={"Zaehler*"} noHover={true}>
                <IsNumericTextBox {...props} />
            </FieldInstance>
        )
    }

    private renderSQL = () => {
        const props = this.factory.getDefaultTextBoxProps();
        //props.required = true;
        props.value = this.state.query;
        props.field.multiLine = true;
        props.onChange = (_, value: string) => {
            this.setState({ query: value }, () => {
                this.props.onChange(this.props.field, this.props.value, {columns: [], query: value});
            });
        }


        return (
            <FieldInstance label={Helper.getTranslation("WebCRM.Email.DataSourceQuery") + "*"} noHover = { true} >
                <TextBox {...props} />
            </FieldInstance>
        )
    }

    componentDidMount() {
        this.loadSQL();
    }

    render() {
        return (
            <>
                <div style={{ display: this.state.loadingState != "loading" ? "none" : "flex", justifyContent: "center", alignItems: "center", height: "120px" }}>
                    <div style={{ width: "fit-content", height: "fit-content" }}>
                        <FAIcon name="spinner" prefix={"fas"} spins={true} attributes={["spin", "5x"]} style={{ color: "#767676" }} />
                    </div>
                </div>
                <div style={{ display: this.state.loadingState == "loading" ? "none" : "flex", flexDirection: "column" }}>
                    {this.renderGruppeTextBox()}
                    {this.renderZaehlerTextBox()}
                    {this.renderSQL()}
                </div>
            </>
            
        );
    }
}